import React, { useEffect } from 'react'
import { ReactComponent as IconInfo } from "assets/images/icons/project-icons/info-icon-orange.svg"
import { useState } from 'react'
import { useLocation } from 'react-router-dom'

const useWarningMessage = () => {
    const location = useLocation();
    const [warningShown, setWarningShown] = useState(false);
    
    const isBillPaymentRoute = location?.pathname?.includes("/payments/bills/")
    
    const WarningMessage = ({data, dependencies}) => {
        
        useEffect(() => {
            const itemBelowMinimum = data?.filter((item) => item?.amount < 50)
            
            if(itemBelowMinimum?.length > 0) {
                setWarningShown(true);
            } else {
                setWarningShown(false);
            }
            
            // eslint-disable-next-line
        }, dependencies)
        
        return (
            <div className={`flex items-center justify-center mt-5 w-full bg-[#FEF5E7] text-[#101828] p-3 rounded-lg mb-4 transition-opacity duration-300 ${warningShown ? "opacity-100" : "opacity-0"}`}>
                <div><IconInfo /></div>
                <div className="text-sm ml-2">You cannot {isBillPaymentRoute ? "purchase" : "send"} less than 50 Naira {isBillPaymentRoute ? "for" : "to"} a recipient</div>
            </div>
        )
    }
    
    return { WarningMessage, warningShown }
}

export default useWarningMessage